import React  from 'react';
import {findDOMNode} from "react-dom";
import PropTypes from 'prop-types';
import PopoverComponent from "../../../../gd-components/base-component/popover-component";

import HintPopover from "../../../../gd-ui/hint-popover/hint-popover";
import Popover from "../../../../gd-components/gd-popover/popover";
import TextEditPopoverForm from "../../components/text-edit/text-edit-popover-form";

import Classes from 'classnames';

export default class CommentsProto extends PopoverComponent {

    static propTypes = {
        renderMode: PropTypes.oneOf(['list','view']),

        placeholder: PropTypes.string,
        item: PropTypes.object,
        disabled: PropTypes.bool,

        onChange: PropTypes.func,

        attachment: PropTypes.string,
        targetAttachment: PropTypes.string,
        targetOffset: PropTypes.string,
        attachmentType: PropTypes.string
    }

    constructor(props) {
        super(props);

        this.state = {
            comments: this.props.item.statusComments
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.comments !== this.props.item.statusComments) {
            this.setState({
                comments: this.props.item.statusComments
            });
        }
    }

    onSave = (value) => {
        this.setState({
            showPopover: false,
            comments: value
        }, ()=>{
            if (this.props.onTogglePopover) this.props.onTogglePopover(false);
            if (this.props.onChange) this.props.onChange(value);
        })
    }

    renderPopover() {
        if (this.state.showPopover) {

            return (
                <Popover popoverClass="gd-field-text-edit-popover"
                         className="gd-field-text-edit-popover-container"
                         attachment={this.props.attachment ? this.props.attachment : 'top center'} //defaultProps somehow doesn't work
                         targetAttachment={this.props.targetAttachment ? this.props.targetAttachment : 'bottom center'}
                         targetOffset={this.props.targetOffset}
                         attachmentType={this.props.attachmentType ? this.props.attachmentType : 'horizontal'}
                         getTargetFunc={()=>findDOMNode(this)}
                         onClickOutside={()=>{this.hidePopover()}}>

                    <TextEditPopoverForm text={this.props.item.statusComments} onSave={this.onSave}/>

                </Popover>
            );
        }
    }

    render() {
        const classes = Classes("gd-field-comments", this.props.renderMode, this.props.className);
        return (
            <div className={classes} onClick={this.props.disabled ? null : this.togglePopover}>
                {this.state.comments}
                {!this.state.comments && !!this.props.placeholder &&
                <div className="placeholder">{this.props.placeholder}</div>}

                {!this.state.showPopover &&
                <HintPopover parent={this}
                             hint={this.state.comments}
                             checkShowHint={()=> {
                                 const node = findDOMNode(this);
                                 return node.clientHeight < node.scrollHeight;
                             }}
                             multiline={true}/>}

                {this.renderPopover()}
            </div>
        );
    }
}